import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    cancel: 'Cancel',
    description: 'Send manually your quote as a PDF.',
    downloadPdf: 'Download PDF',
    title: 'Sharing method',
  },
  fr: {
    cancel: 'Annuler',
    description: 'Envoyez manuellement votre devis en PDF.',
    downloadPdf: 'Télécharger la facture PDF',
    title: 'Mode de partage',
  },
});
